import { IconCredits } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import { mergeWith, subtract } from 'lodash-es';
import { clone, isNonNullish } from 'remeda';
import { useLoadAgedBalanceCompact } from 'shared/hooks/use-load-aged-balance';
import { useSafeLocalizedCompactCurrencyFormatter } from 'shared/utils/currency';

import { BaseTicker } from '../BaseTicker';

export const TotalReceivableTicker = () => {
  const { t } = useTranslation();
  const { agedBalanceCompact, agedBalanceCompactError, isAgedBalanceCompactLoading } =
    useLoadAgedBalanceCompact();
  const formatter = useSafeLocalizedCompactCurrencyFormatter(false);

  if (isAgedBalanceCompactLoading || agedBalanceCompact == null) {
    return (
      <BaseTicker
        icon={IconCredits}
        label={t(i18nKeys.ANALYTICS.TICKERS.TOTAL.TITLE)}
        hasFailed={isNonNullish(agedBalanceCompactError)}
      />
    );
  }

  const netAgedBalance = mergeWith(
    clone(agedBalanceCompact.debits),
    agedBalanceCompact.credits,
    subtract,
  );

  const totalReceivable =
    netAgedBalance.notDue +
    netAgedBalance['0'] +
    netAgedBalance['30'] +
    netAgedBalance['60'] +
    netAgedBalance['90'];

  return (
    <BaseTicker
      icon={IconCredits}
      label={t(i18nKeys.ANALYTICS.TICKERS.TOTAL.TITLE)}
      value={formatter.format(totalReceivable)}
      url="analytics/aged-balance"
    />
  );
};
